import { CircleCheck, LoaderCircle } from 'lucide-react';
import { AnimatePresence, motion } from 'motion/react';
import { useState } from 'react';

interface ExportLoaderProps {
  complete?: boolean;
  error?: boolean;
  loadingText?: string;
  completeText?: string;
  onCompleteAnimationEnd?: () => void;
}

const DELAY = 1500;

export const ModalFooterLoadingIndicator = ({
  complete,
  error,
  loadingText,
  completeText,
  onCompleteAnimationEnd,
}: ExportLoaderProps) => {
  const [mount, setMount] = useState(true);

  const handleAnimationComplete = () => {
    setTimeout(() => {
      setMount(false);
    }, DELAY);
  };

  const loading = !complete && !error;

  return (
    <div className="me-auto flex flex-row gap-2 items-center">
      <AnimatePresence mode="wait">
        {loading ? (
          <motion.div
            key={'loading'}
            animate={{
              opacity: 1,
              rotate: 360,
              transition: {
                repeat: Infinity,
                duration: 1.5,
                ease: 'linear',
              },
            }}
            exit={{ opacity: 0 }}
          >
            <LoaderCircle size={28} className="text-primary-100" />
          </motion.div>
        ) : (
          <AnimatePresence mode="wait" onExitComplete={onCompleteAnimationEnd}>
            {mount && complete && (
              <motion.div
                key={'complete'}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1, transition: { duration: 0.5 } }}
                exit={{ opacity: 0, transition: { duration: 0.5 } }}
                onAnimationComplete={handleAnimationComplete}
              >
                <CircleCheck
                  size={28}
                  className="text-white fill-primary-100"
                />
              </motion.div>
            )}
          </AnimatePresence>
        )}
        {loading ? (
          <motion.p
            key={'loading-text'}
            className="animate-pulse text-base text-grey-100"
          >
            {loadingText}
          </motion.p>
        ) : (
          <AnimatePresence mode="wait">
            {mount && complete && (
              <motion.p
                key={'complete-text'}
                exit={{ opacity: 0, transition: { duration: 0.5 } }}
                className="text-base text-grey-100"
              >
                {completeText}
              </motion.p>
            )}
          </AnimatePresence>
        )}
      </AnimatePresence>
    </div>
  );
};
